// The answer control for "draw the missing column" questions (15 Oct 2026):
// two buttons for each column to draw, one to make it taller and one to make
// it shorter. The column itself grows on the graph above (PracticeTask.tsx).
// A column's height is never printed for the eye: reading it off the scale is
// the skill. It is given to screen readers, who cannot see the graph.
import {
  splitBuilt,
  stepBuilt,
  type BuildQuestion,
} from '../../platform/content/buildGraphAnswer';

type Props = {
  question: BuildQuestion;
  value: string;
  disabled: boolean;
  onChange: (value: string) => void;
};

export function BuildGraphAnswer({
  question,
  value,
  disabled,
  onChange,
}: Props) {
  const heights = splitBuilt(value, question);
  return (
    <div className="grid gap-2.5">
      {question.bars.map((bar) => {
        const height = heights.get(bar.id) ?? 0;
        return (
          <div
            key={bar.id}
            role="group"
            aria-label={`${bar.label} column`}
            className="grid grid-cols-2 items-center gap-2 rounded-xl border border-line bg-white px-3 py-2 sm:grid-cols-[1fr_auto_auto]"
          >
            <span className="col-span-2 font-semibold text-forest-950 sm:col-span-1">
              {bar.label}
            </span>
            <span role="status" className="sr-only">
              {bar.label} column: {String(height)}
            </span>
            <button
              type="button"
              className="dm-btn-secondary min-h-11"
              disabled={disabled || height === 0}
              onClick={() => {
                onChange(stepBuilt(value, question, bar.id, -1));
              }}
            >
              <span aria-hidden="true">▼ </span>Shorter
            </button>
            <button
              type="button"
              className="dm-btn-secondary min-h-11"
              disabled={disabled || height >= question.graph.max}
              onClick={() => {
                onChange(stepBuilt(value, question, bar.id, 1));
              }}
            >
              <span aria-hidden="true">▲ </span>Taller
            </button>
          </div>
        );
      })}
    </div>
  );
}
